/**
 * One-time injection of mentor-scoped CSS keyframes.
 *
 * We avoid pulling in a CSS-in-JS dep just for two keyframes: the
 * overlay calls `ensureMentorStylesInjected()` once on mount and the
 * helper is a no-op on subsequent calls. SSR-safe.
 *
 * Styles:
 *   - staylayer-mentor-fade-in: 180ms opacity 0→1, used by CoachingCard
 *   - staylayer-mentor-sr-only: visually-hidden helper for the
 *     screen-reader live region (no animation)
 */

const STYLE_ID = "staylayer-mentor-styles";

const CSS = `
@keyframes staylayer-mentor-fade-in {
  from { opacity: 0; transform: translateY(2px); }
  to   { opacity: 1; transform: translateY(0); }
}
.staylayer-mentor-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
`;

export function ensureMentorStylesInjected(): void {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;
  const tag = document.createElement("style");
  tag.id = STYLE_ID;
  tag.textContent = CSS;
  document.head.appendChild(tag);
}
